export default {
  FIRSTNAME: {
    field: 'firstName',
    multiple: false,
    required: true,
  },
  LASTNAME: {
    field: 'lastName',
    multiple: false,
    required: true,
  },
  EMAIL: {
    field: 'email',
    multiple: false,
    required: true,
  },
  ROLE: {
    field: 'role',
    multiple: false,
  },
  MOBILE: {
    field: 'mobilePhone',
    multiple: false,
  },
  // we need to discusss on how to handle permissions in excel import with out updating license
  // PERMISSIONS: {
  //   field: 'permissions',
  // },

};
